"use client";
import {
  createDisclosureStore
} from "./Z5IGYIPT.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
